import React from 'react';

import { components } from 'react-select';

export function MenuWithEnd({ selectProps, children, ...props }) {
	const { locationContainerDisclaimer } = selectProps;

	return (
		<components.Menu {...props}>
			<div>{children}</div>
			{locationContainerDisclaimer && (
				<p
					className='cgr'
					style={{
						padding: '8px 12px',
						borderTop: '1px solid #dadedd',
					}}
				>
					{locationContainerDisclaimer}
				</p>
			)}
		</components.Menu>
	);
}
